"use client";

import React from "react";

export interface UniversityLogo {
  src: string;
  alt: string;
}

export interface UniversityCarouselProps {
  title?: string;
  logos?: UniversityLogo[];
  animationDuration?: string;
}

export function UniversityCarousel({
  title = "Alli's University Partners",
  logos = [
    { src: "https://cdn.prod.website-files.com/65154e68ae1ad53c6e8aaa1a/651d08c35bb9107daa14b09c_1%20(1).jpg", alt: "University" },
    { src: "https://cdn.prod.website-files.com/65154e68ae1ad53c6e8aaa1a/651d08c323ee2d3ef792f3a4_6%20(2).jpg", alt: "University" },
    { src: "https://cdn.prod.website-files.com/65154e68ae1ad53c6e8aaa1a/651d08c30b4ef509c91dbc83_2%20(1).jpg", alt: "University" },
    { src: "https://cdn.prod.website-files.com/65154e68ae1ad53c6e8aaa1a/651d08c3d335df8b3a413680_5.jpg", alt: "University" },
    { src: "https://cdn.prod.website-files.com/65154e68ae1ad53c6e8aaa1a/651d08c342ddf9001f4fe15a_7.jpg", alt: "University" },
    { src: "https://cdn.prod.website-files.com/65154e68ae1ad53c6e8aaa1a/651d0ac148b2738217ce253c_9.jpg", alt: "University" },
    { src: "https://cdn.prod.website-files.com/65154e68ae1ad53c6e8aaa1a/651d0ab73d42348577794cf4_8.jpg", alt: "University" }
  ],
  animationDuration = "120s"
}: UniversityCarouselProps) {
  return (
    <section className="pt-12 pb-20 bg-white">
      <div className="max-w-7xl mx-auto">
        <p className="text-center text-sm text-gray-500 mb-12 uppercase tracking-widest font-medium">
          {title}
        </p>
        
        <div className="relative overflow-hidden px-4">
          <div 
            className="flex items-center"
            style={{
              animation: `scroll ${animationDuration} linear infinite`,
              display: 'flex',
              width: 'max-content'
            }}
          >
            {/* First set of universities */}
            {logos.map((logo, index) => (
              <img 
                key={`first-${index}`}
                src={logo.src} 
                alt={logo.alt} 
                className="h-24 w-auto object-contain opacity-90 mx-6" 
              />
            ))}
            
            {/* Duplicate set for seamless loop */}
            {logos.map((logo, index) => (
              <img 
                key={`second-${index}`}
                src={logo.src} 
                alt={logo.alt} 
                className="h-24 w-auto object-contain opacity-90 mx-6" 
              />
            ))}
          </div>
          
          {/* Gradient overlays */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent pointer-events-none z-10"></div>
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent pointer-events-none z-10"></div>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        
        div[style*="animation"]:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
}